<template>
  <div search :class="{ on: searchMode, hasSearchData }">
    <div class="backdrop"></div>
    <div class="close-wrap"><a class="close" @click="close"></a></div>
    <div class="scroll-holder">
      <div class="sticky">
        <div class="result-count" v-if="hasSearchData">
          <span v-if="isEmpty(result)">No results found for “{{ searchWord }}”</span>
          <span v-else>{{ result.length }} results for “{{ searchWord }}”</span>
        </div>
        <section class="search">
          <input id="searchInput" v-model="searchData" placeholder="search" @keydown.prevent.enter="searchAct" @keyup="changeFontSize">
          <div class="quick" v-if="!hasSearchData">
            <label>Recommend tag</label>
            <ul>
              <li v-for="row in quickList" :key="row">
                <!-- <locale-link :to="row.data.route">{{ row.label }}</locale-link>-->
                <a @click="onSearch(row)">{{ row }}</a>
              </li>
            </ul>
          </div>
        </section>
      </div>
      <template v-if="hasSearchData">
        <section class="result" v-if="!isEmpty(result)">
          <ul>
            <li v-for="(item, i) in result" :key="i">
              <a @click="linkTo(`/works/article/${item.slug}`)">
                <div class="img">
                  <cdn-img :src="item.image" class="hidden-tp-down" v-if="matchMediaType(item.image, 'image')"/>
                  <cdn-video :src="item.image" loop autoplay muted playsinline class="hidden-tp-down" v-if="matchMediaType(item.image, 'video')"/>
                  <cdn-img :src="getMobileThumb(item)" class="hidden-tl-up" v-if="matchMediaType(getMobileThumb(item), 'image')"/>
                  <cdn-video :src="getMobileThumb(item)" loop autoplay muted playsinline class="hidden-tl-up" v-if="matchMediaType(getMobileThumb(item), 'video')"/>
                </div>
                <div class="text">
                  <p v-html="enterToBr(item.title)"></p>
                </div>
              </a>
            </li>
          </ul>
        </section>
      </template>
    </div>
  </div>
</template>


<script>
import oax from '@/utils/oax';
import CdnImg from '@/views/components/CdnImg.vue';
import { sleep, values } from '@/utils';
import Vue from 'vue';
import CdnVideo from '@/views/components/CdnVideo.vue';

export default {
  name: 'Search',
  components: { CdnVideo, CdnImg },
  data() {
    return {
      searchData: '',
      searchWord: '',
      quickList: null,
      currentFs: 0,
      result: null,
    };
  },
  watch: {
    async $route(to, from) {
      if (to.params.locale !== from.params.locale) {
        await this.getQuickLink();
      }
      this.reset();
    },
    matchedMedia() {
      this.changeFontSize();
    },
  },
  computed: {
    searchMode() {
      return this.$store.state.searchMode;
    },
    hasSearchData() {
      return this.$route.query.searchData;
    },
  },
  methods: {
    getMobileThumb(e) {
      return e.mobileThumb || e.image;
    },
    getFontSize() {
      if (this.matchedMedia in values('DX')) return 120;
      if (this.matchedMedia in values('TL', 'DS', 'DM', 'DL')) return 80;
      return 48;
    },
    changeFontSize() {
      const myInput = document.getElementById('searchInput');
      if (this.isOverflown(myInput)) {
        while (this.isOverflown(myInput)) {
          this.currentFs--;
          myInput.style.fontSize = this.currentFs + 'px';
        }
      } else {
        this.currentFs = this.getFontSize();
        myInput.style.fontSize = this.currentFs + 'px';
        while (this.isOverflown(myInput)) {
          this.currentFs--;
          myInput.style.fontSize = this.currentFs + 'px';
        }
      }
    },
    isOverflown(el) {
      return el.scrollWidth > el.clientWidth && this.currentFs > 8;
    },
    searchAct(e) {
      if (e?.isComposing) return;
      if (!this.searchData) {
        window.alert('검색어를 입력해주세요');
        return;
      }
      this.$router.push({ query: { searchData: this.searchData } });
    },
    onSearch(tag) {
      this.$router.replace({ query: { searchData: tag } });
    },
    async close() {
      this.$scroll.release();
      this.$store.commit('isFirst', false);
      this.$store.commit('searchMode', false);
      if (this.hasSearchData) this.$router.replace({ 'query': null });
      await sleep(500);
      this.searchData = '';
      this.result = null;
    },
    async getQuickLink() {
      // const { data } = await oax.get(`/api/quickLink`, { lang: this.lang });
      // const list = _.uniqBy(_.map(data, row => _.pickBy(row, _.identity)), 'priorityCategory').slice(0, 5);
      // this.quickList = this.fullCodeList.filter(row => list.some(e => e.priorityCategory === row.code));
      this.quickList = (await oax.get('/api/lexicon', { lang: this.lang })).data.slice(0, 25);
    },
    async getList() {
      this.result = (await oax.get('/api/article', { lang: this.lang, tag: encodeURIComponent(this.searchData) })).data.list;
      this.searchWord = this.searchData;
    },
    reset() {
      this.searchData = this.$route.query.searchData;
      Vue.nextTick(() => {
        this.changeFontSize();
      });
      if (this.searchData) {
        this.$scroll.freeze();
        this.$scroll.scrollTo(0);
        this.$store.commit('searchMode', true);
        this.getList();
      } else {
        this.$scroll.release();
        this.$store.commit('searchMode', false);
      }
    },
  },
  mounted() {
    this.getQuickLink();
    this.reset();
  },
  beforeDestroy() {
  },
};
</script>

<style lang="less">
@import '~@/less/proj.less';
[search] { .abs; .lt; z-index: 999; .wf; .fvh; .-box; transform: translateX(-100%); transition: transform 0s; .tr-d(0s); color: #fff;
  .first & {
    .backdrop, .close, section.search { transition-duration: 0s; .tr-d(0s); }
  }
  &.on { transform: translateX(0); transition: tranform 0s; .tr-d(0s);
    .backdrop, .close { .o(1); }
    .sticky { .o(1); .t-y(0); }
  }
  &.hasSearchData { background: #000; }
  .scroll-holder { .rel; .f; overflow-y: auto; }
  .sticky { .sticky; .lt; z-index: 3; .pt(60); .o(0); .t-y(-20%); transition: all .5s cubic-bezier(.59, .01, .28, 1); background: #000;
  }
  .backdrop { .fix; .lt; .f; background: rgba(0, 0, 0, 0.9); .o(0); .tr-o(.4s); }
  .result-count { .abs; left: 0; right: 0; .t(27); .space-d; pointer-events: none; z-index: 1;
    span { .block; .fs(18, 28); .pr(72); .ellipsis; }
  }
  .close-wrap { .rel; .space-d; }
  .close { .block; .abs; .rt(10, 15); .wh(52); .no-repeat('/img/common/ico-close.svg'); .bg-s(32, 32); .bg-c; .o(0); .tr-o(.4s); z-index: 9;
    &:before { .cnt; .abs; .lt; .f; .br(50%); .bgc(rgba(0, 0, 0, 0.08)); .o(0); transition: opacity .3s ease;
      .dark & { .bgc(rgba(255, 255, 255, 0.08)); }
    }
    .no-touch &:hover:before { .o(1); }
  }
  section { .rel; .space-m;
    &.search { .p(30, 20);
      input { .block; .wf; .fs(48, 1.2); .c(#fff); .min-h(58);
        &::placeholder { .c(rgba(255, 255, 255, 0.20)); }
      }
      .quick { .pt(24);
        label { .block; .fs(14, 1.2); .c(rgba(255, 255, 255, 0.6)); }
        ul { .mt(24);
          li { .ib; .mr(8); .mb(8);
            a { .block; .fs(13, 20); .p(3, 8); .br(3); .-a(#E3E3E3); .c(#E3E3E3); text-decoration: none;
              .no-touch &:hover { .bgc(#E3E3E3); .c(#000); }
            }
          }
        }
      }
    }
    &.result { .pb(100);
      > ul { .rel; .pt(20); display: grid; grid-template-columns: 1fr; row-gap: 40px;
        > li { .rel;
          .img { aspect-ratio: 16 / 9; .crop; .br(5); }
          [cdn-img], [cdn-video] { .rel; .f; object-fit: cover; transform: scale(1); .o(1); transition: transform 1s cubic-bezier(0, 0, 0.13, 1.04), opacity .6s ease;}
          .text { .mt(15);
            p { .fs(20, 1.2); }
            p + p { .mt(12); .fs(16, 24, -0.25); }
          }
          .no-touch &:hover {
            [cdn-img], video {transform: scale(1.1);}
            &.has-video [cdn-img] { .o(0); }
          }
        }
      }
    }
    &.no-list {.tc; .pt(108); .fs(16); .medium;}
  }
}
@media (min-width: @screen-tp-min) {
  [search] {
    section {
      &.result > ul > li {
        .text { display: grid; grid-template-columns: 1fr 1fr; column-gap: 10px;
          p + p { .mt(0); }
        }
      }
    }
  }
}
@media (min-width: @screen-tl-min) {
  [search] {
    .close { .t(25); }
    .result-count { .t(37); }
    section {
      &.search {
        input { .fs(80, 1.2); .min-h(96); }
      }
      &.result {
        > ul { .pt(24); grid-template-columns: 1fr 1fr; column-gap: 20px; row-gap: 60px;
          > li {
            &.highlight { grid-column: span 2;
              .img { aspect-ratio: 16 / 9; }
            }
            .text { .mt(20);
              p { .fs(22, 1.2); }
            }
          }
        }
      }
    }
  }
}
@media (min-width: @screen-dm-min) {
  [search] {
    .sticky { .pt(120); }
    .result-count span { .fs(24, 28); }
    section { .space-d;
      &.result {
        > ul {
          > li {
            .text {
              p { .fs(26, 1.2); }
            }
          }
        }
      }
    }
  }
}
@media (min-width: @screen-dx-min) {
  [search] {
    .result-count { .t(34); span { .fs(28, 34); } }
    section { .space-d;
      &.search {
        input { .fs(120, 1.2); }
      }
    }
  }
}
</style>